import { useTranslation } from "react-i18next";

export default function HomeStatStrip() {
  const { t } = useTranslation("pages");

  const stats = [
    { value: "0.2–0.7", unit: "s", label: t("home.stats.latency") },
    { value: "4", unit: t("home.stats.carsUnit"), label: t("home.stats.cars") },
    { value: "ms", unit: "", label: t("home.stats.precision") },
    { value: "0", unit: "", label: t("home.stats.hardware") },
  ];

  return (
    <section className="border-y border-gray-800 bg-gray-950">
      <dl className="mx-auto grid max-w-6xl grid-cols-2 px-6 lg:grid-cols-4">
        {stats.map((stat) => (
          <div
            key={stat.label}
            className="border-gray-800 px-5 py-5 first:pl-0 odd:border-r [&:nth-child(-n+2)]:border-b lg:border-r lg:py-6 lg:last:border-r-0 lg:[&:nth-child(-n+2)]:border-b-0"
          >
            <dd className="font-mono text-2xl font-semibold tabular-nums tracking-[-0.02em] text-white">
              {stat.value}
              {stat.unit && (
                <small className="ml-1.5 text-xs font-normal text-gray-400">
                  {stat.unit}
                </small>
              )}
            </dd>
            <dt className="mt-1 text-xs text-gray-400 sm:text-[13px]">
              {stat.label}
            </dt>
          </div>
        ))}
      </dl>
    </section>
  );
}
